import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { Link, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { ROUTES } from "constants/routes"
import LanguageDropdown from "components/CommonForBoth/TopbarDropdown/LanguageDropdown"
import { applyDocumentLanguage } from "utils/i18nDocument"
import wuloojLogo from "assets/images/superadmin/wulooj-logo-full.png"
import landingBg from "assets/images/wulooj-landing-bg.png"
import "./onboarding.scss"
import usePlatformAuthChrome from "hooks/usePlatformAuthChrome"
import { usePortalTenant } from "context/PortalTenantContext"

const REGISTRATION_FLOW_PATHS = [
  ROUTES.REGISTER,
  ROUTES.REGISTER_PLANS,
  ROUTES.REGISTER_PAYMENT,
]

const OnboardingLayoutInner = ({ children, showHeaderActions = true }) => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const { isCustomLoginActive } = usePortalTenant()
  const showOnboardingActions = showHeaderActions && !isCustomLoginActive
  const isInRegistrationFlow = REGISTRATION_FLOW_PATHS.some(
    path => pathname === path || pathname.startsWith(`${path}/`)
  )

  usePlatformAuthChrome(true, t("Create Account"))

  useEffect(() => {
    const lang = localStorage.getItem("I18N_LANGUAGE") || "en"
    applyDocumentLanguage(lang)
  }, [])

  const handleTryNowClick = e => {
    if (isInRegistrationFlow) {
      e.preventDefault()
    }
  }

  return (
    <div className="onboarding-page">
      <div
        className="onboarding-page__bg"
        style={{ backgroundImage: `url(${landingBg})` }}
        aria-hidden="true"
      />
      <header className="onboarding-header">
        <Link to={ROUTES.LANDING}>
          <img src={wuloojLogo} alt="Wulooj" className="onboarding-logo" />
        </Link>
        {showOnboardingActions && (
          <div className="onboarding-header-actions">
            <LanguageDropdown />
            <Link
              to={ROUTES.LOGIN}
              className="onboarding-btn onboarding-btn--ghost"
            >
              {t("Login")}
            </Link>
            <Link
              to={ROUTES.REGISTER}
              state={isInRegistrationFlow ? undefined : { startFresh: true }}
              className={`onboarding-btn onboarding-btn--primary${
                isInRegistrationFlow ? " onboarding-btn--try-now-active" : ""
              }`}
              onClick={handleTryNowClick}
              aria-current={isInRegistrationFlow ? "page" : undefined}
            >
              {t("Try Now")}
            </Link>
          </div>
        )}
      </header>
      <main className="onboarding-content">{children}</main>
    </div>
  )
}

OnboardingLayoutInner.propTypes = {
  children: PropTypes.node,
  showHeaderActions: PropTypes.bool,
}

const OnboardingLayout = props => <OnboardingLayoutInner {...props} />

export default OnboardingLayout
